export default "__VITE_ASSET__BCErLMYM__"